import React from "react";

interface Props {
  data: any;
}

const CardsGrid: React.FC<Props> = ({ data }) => {
  const colorMap: Record<any, any> = {
    primary: "#00d1b2",
    success: "#23d160",
    info: "#209cee",
    warning: "#ffdd57",
  };

  console.log("card data", data);

  const cardData = [
    { title: "Loco Pilots", value: data?.total_trainees, bgColor: "primary" },
    { title: "Completed", value: data?.completed_users, bgColor: "info" },
    { title: "Pending", value: data?.active_users, bgColor: "success" },
    {
      title: "Score(%)",
      value: isNaN(parseFloat(data?.session_score))
        ? "0"
        : parseFloat(data?.session_score).toString(),
      bgColor: "warning",
    },
  ];

  return (
    <div className="columns is-multiline">
      {cardData.map((card, index) => (
        <div key={index} className="column is-one-sixth">
          <div
            className="box exact-card has-background-light"
            style={{ borderLeft: `5px solid ${colorMap[card.bgColor]}` }}
          >
            <div className="card-content is-flex is-align-items-center is-justify-content-space-between">
              <span className="card-title has-text-weight-semibold">
                {card.title}
              </span>
              <span
                className={`is-size-5 has-text-white smart-card-count ml-6 has-background-${card.bgColor}`}
              >
                {card.value ?? 0}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardsGrid;
